export default __webpack_public_path__ + "static/media/car.66e199ea.svg";